
































































































































import type { PropType } from '@vue/composition-api';
import { onBeforeUnmount, onMounted, computed, defineComponent, ref } from '@vue/composition-api';
import type { Cell } from '@getaccept/editor-lib';
import {
  SlideShowBottomBar,
  SlideShowTopBar,
  useSlideShow,
  EBlockWidth,
  RowType,
} from '@getaccept/editor-lib';
import { ObserveVisibility } from 'vue-observe-visibility';
import EditorCell from './EditorCell.vue';

export default defineComponent({
  name: 'EditorRowSlideShow',
  components: {
    EditorCell,
    SlideShowBottomBar,
    SlideShowTopBar,
  },
  directives: {
    'observe-visibility': ObserveVisibility,
  },
  props: {
    cells: {
      type: Array as PropType<Cell[]>,
      default: () => [],
    },
    blockWidthClass: { type: String as PropType<EBlockWidth>, default: null },
    rowType: { type: String as PropType<RowType>, default: null },
    isBlockToggled: { type: Boolean, default: false },
    pageWidth: { type: Number, default: null },
    rowId: { type: String, default: null },
  },
  setup(props, { root }) {
    const {
      current,
      transitionName,
      isGridView,
      isSticky,
      slides,
      gridSlides,
      observerOptions,
      slide,
      handleToggleGridView,
      handleClick,
      currentSlide,
      handleKeyDown,
      handleDragStart,
      handleDragEnd,
      isLightboxView,
      handleToggleLightBoxView,
      handleShowToolbar,
      showToolbar,
      lightboxContainerRef,
      handleResize,
      removeLightBoxQuery,
      lightboxRoute,
      isSmallScreen,
    } = useSlideShow(props, root);

    const rowTypeClass = computed(() => `row-type-${props.rowType?.toLowerCase()}`);
    const isMouseOver = ref(false);

    const isParentFirstChild = (index: number) => index === 0;

    const isParentLastChild = (index: number) => index === props.cells.length - 1;

    const handleMouseOver = () => {
      isMouseOver.value = true;
    };

    const handleKeyBoardNavigation = (event: KeyboardEvent) => {
      if (isLightboxView.value) {
        handleKeyDown(event);
      }
    };

    const handleMouseOut = () => {
      isMouseOver.value = false;
    };

    onMounted(() => {
      window.visualViewport.addEventListener('resize', handleResize);
      window.addEventListener('keydown', handleKeyBoardNavigation);
      removeLightBoxQuery();
    });

    onBeforeUnmount(() => {
      window.visualViewport.removeEventListener('resize', handleResize);
      window.removeEventListener('keydown', handleKeyBoardNavigation);
    });

    return {
      rowTypeClass,
      current,
      transitionName,
      slides,
      RowType,
      lightboxRoute,
      currentSlide,
      handleClick,
      isParentFirstChild,
      isParentLastChild,
      handleToggleGridView,
      EBlockWidth,
      slide,
      isGridView,
      handleDragEnd,
      handleDragStart,
      observerOptions,
      isSticky,
      gridSlides,
      handleMouseOver,
      handleMouseOut,
      isMouseOver,
      isLightboxView,
      handleToggleLightBoxView,
      handleShowToolbar,
      showToolbar,
      lightboxContainerRef,
      isSmallScreen,
    };
  },
});
